const accountPaths = {
  recentActivities: '/account/recent-activity',
  account: '/account/account/edit',
  notification: '/account/notification',
  accountTestOrders: '/account/test-orders',
};

export default accountPaths;
